module.exports = __webpack_public_path__ + "static/media/Redux Icon.1535aa30.png";